export const DEVICE_OPTIONS_QUERY_KEY = ["device-options"] as const;
